<template>
  <div class="main-container">
    <hi-header :color="color" :theme="theme"></hi-header>
    <slot></slot>
  </div>
</template>

<script>
import bus from "./../bus";

export default {
  data() {
    return {
      // Default values
      color: "",
      theme: "start",
    };
  },
  created() {},
};
</script>
